export default "__VITE_ASSET__DA9xHiD9__"